<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <!-- <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button> -->
                         <el-input
                            size="small"
                            style="width:230px;"
                            placeholder="请输入用户手机号 / 店铺名称"
                            prefix-icon="el-icon-search"
                            @keydown.enter.native="query"
                            v-model="queryModel.queryTxt">
                        </el-input>
                        <el-select size="small" style="margin-left:30px;width:100px"  v-model="queryModel.type" clearable placeholder="店铺类型">
                            <el-option key="1" label="淘宝" value="1"> </el-option>
                            <el-option key="2" label="京东" value="2"> </el-option>
                            <el-option key="3" label="拼多多" value="3"> </el-option>
                            <el-option key="4" label="快手" :value="4"> </el-option>
                            <el-option key="5" label="阿里巴巴" :value="5"> </el-option>
                            <el-option key="6" label="抖音" :value="6"> </el-option>
                        </el-select>
                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.status" clearable placeholder="店铺状态">
                            <el-option key="1" label="待审核" value="1"> </el-option>
                            <el-option key="2" label="正常" value="2"> </el-option>
                            <el-option key="3" label="不通过" value="3"> </el-option>
                            <el-option key="4" label="关闭" value="4"> </el-option>
                        </el-select>
                        <el-select size="small" style="width:150px;margin-left:30px" v-model="queryModel.grade" clearable placeholder="请选择店铺等级">
                            <el-option label="A" :value="3"></el-option>
                            <el-option label="B" :value="2"></el-option>
                            <el-option label="C" :value="1"></el-option>
                        </el-select>
                        <el-select size="small" style="width:200px;margin-left:30px" v-model="queryModel.categoryId" clearable placeholder="请选择店铺类目">
                            <el-option
                            v-for="item in categorys"
                            :key="item.Id"
                            :label="item.Value"
                            :value="item.Id">
                            </el-option>
                        </el-select>
                        <el-select size="small" style="width:100px;margin-left:30px" v-model="queryModel.lastReleaseDay" clearable placeholder="流失天数">
                            <el-option label="一天" :value="1"></el-option>
                            <el-option label="三天" :value="3"></el-option>
                            <el-option label="七天" :value="7"></el-option>
                            <el-option label="十五天" :value="15"></el-option>
                            <el-option label="三十天" :value="30"></el-option>
                        </el-select>
                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    :height="bodyHeight-130"
                    v-loading="isLoading"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            label="店铺名称">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Type==1" ><img style="margin-bottom:-8px;height:23px"  src="../assets/tb.jpg"><b style="margin-left:5px">{{scope.row.Name}}</b></span>
                                <span v-else-if="scope.row.Type==2" ><img  style="margin-bottom:-8px;height:23px" src="../assets/jd.jpg"><b style="margin-left:5px">{{scope.row.Name}}</b></span>
                                <span v-else-if="scope.row.Type==6" ><img  style="margin-bottom:-6px;height:23px" src="../assets/dy.jpg"><b style="margin-left:5px">{{scope.row.Name}}</b></span>
                                <span  v-else><img  style="margin-bottom:-8px;height:23px"  src="../assets/pd.jpg"><b style="margin-left:5px">{{scope.row.Name}}</b></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="MemberName"
                            label="所属用户">
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            width="160"
                            label="创建时间">
                        </el-table-column>
                        <el-table-column
                            label="店铺链接">
                            <template slot-scope="scope">
                                <el-link target="_blank" icon="el-icon-s-shop" :href="scope.row.HomeUrl" type="primary">首页</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="店铺图片">
                            <template slot-scope="scope">
                                <el-link @click="showImg(scope.row.ImgSrc)" icon="el-icon-picture" type="primary">点击查看</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="阿里旺旺"
                            width="160">
                            <template slot-scope="scope">
                                <el-link icon="el-icon-position" type="primary">{{scope.row.AliTrademanager}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="发货信息">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" placement="bottom-start">
                                    <div slot="content">
                                        电话：{{scope.row.SenderPhone}}<br/><br/>
                                        区域：{{scope.row.SenderArea}}<br/><br/>
                                        地址：{{scope.row.SenderAddress}}<br/><br/>
                                    </div>
                                    <el-link icon="el-icon-map-location" type="primary">{{scope.row.Sender}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="佣金模板">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.CommissionName==''" icon="el-icon-tickets" type="info">暂无</el-link>
                                <el-tooltip v-else  class="item" effect="light" placement="left">
                                    <div slot="content">
                                        <span :key="i"  v-for="(v,i) in scope.row.CommissionDetails">
                                            <el-tag effect="dark"   style="margin-left:10px;width:130px" size="mini"  >
                                                ≤{{v.CriticalValue}}:￥{{v.Commission}}
                                            </el-tag>
                                            <br v-if="(i+1)%2==0" />
                                            <br v-if="(i+1)%2==0" />
                                        </span>
                                    </div>
                                    <el-link  @click="pass(scope.row)" icon="el-icon-tickets" type="primary">{{scope.row.CommissionName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="100"
                            label="店铺等级">
                            <template slot-scope="scope">
                                  <el-tag type="" size="mini" v-if="scope.row.Grade==3" effect="">A </el-tag>
                                  <el-tag type="" size="mini" v-else-if="scope.row.Grade==2" effect="">B </el-tag>
                                  <el-tag type="" size="mini" v-else-if="scope.row.Grade==1" effect="">C </el-tag>
                                  <el-tag type="danger" size="mini" v-else effect="">暂无 </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                        width="100"
                            label="复购天数">
                            <template slot-scope="scope">
                                  <el-tag type="" size="mini" effect="dark">{{ scope.row.Repurchase }} </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="审核信息">
                            <template slot-scope="scope">
                                <el-link v-if="scope.row.ReviewManagerName==''" icon="el-icon-user" type="info">暂无</el-link>
                                <el-tooltip  v-else  class="item" effect="dark" placement="bottom-start">
                                    <div slot="content">
                                        时间：{{scope.row.ReviewTime}}<br/><br/>
                                        备注：{{scope.row.ReviewRemark}}<br/><br/>
                                    </div>
                                    <el-link icon="el-icon-user" type="primary">{{scope.row.ReviewManagerName}}</el-link>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="状态">
                            <template slot-scope="scope">
                                <el-tag size="mini" effect="plain" v-if="scope.row.Status==1">待审核</el-tag>
                                <el-tag size="mini" effect="plain" type="success" v-else-if="scope.row.Status==2">正常</el-tag>
                                <el-tag size="mini" effect="plain" type="warning" v-else-if="scope.row.Status==3">不通过</el-tag>
                                <el-tag size="mini" effect="plain" type="danger" v-else>关闭</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column
                            width="120px"
                            label="操作">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="做单配置" placement="bottom">
                                        <el-button  size="mini"  type="primary" @click="openShopConfig(scope.row)" icon="el-icon-edit" circle></el-button>
                                    </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="审核通过" placement="bottom">
                                    <el-button type="success" size="mini" @click="pass(scope.row)"  icon="el-icon-check" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==1" effect="dark" content="审核不通过" placement="bottom">
                                    <el-button type="warning" size="mini" @click="over(scope.row)"  icon="el-icon-refresh-right" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==2" effect="dark" content="关闭店铺" placement="bottom">
                                    <el-button type="danger" size="mini" @click="del(scope.row)"  icon="el-icon-close" circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="scope.row.Status==4" effect="dark" content="启用店铺" placement="bottom">
                                    <el-button type="success" size="mini" @click="enable(scope.row)"  icon="el-icon-check" circle></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="补充信息" :visible.sync="dialogFormVisible" width="400px">
            <el-form label-width="120px">
                <el-form-item label="店铺类型：">
                    <el-select size="small" style="width:260px"  v-model="overModel.type" clearable placeholder="店铺类型">
                        <el-option key="1" label="淘宝" :value="1"> </el-option>
                        <el-option key="2" label="京东" :value="2"> </el-option>
                        <el-option key="3" label="拼多多" :value="3"> </el-option>
                        <el-option key="4" label="快手" :value="4"> </el-option>
                        <el-option key="5" label="阿里巴巴" :value="5"> </el-option>
                        <el-option key="6" label="抖音" :value="6"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input placeholder="如有需要，填写备注" v-model="overModel.remark"></el-input>
                </el-form-item>
                
                <el-form-item label="佣金模板：">
                     <el-select style="width:260px" v-model="overModel.commissionId" placeholder="请选择佣金模板">
                        <el-option
                        v-for="item in commissions"
                        :key="item.Key"
                        :label="item.Value"
                        :value="item.Key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="店铺类目：">
                     <el-select style="width:260px" v-model="overModel.categoryId" placeholder="请选择店铺类目">
                        <el-option
                        v-for="item in categorys"
                        :key="item.Id"
                        :label="item.Value"
                        :value="item.Id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="店铺等级：">
                     <el-select style="width:260px" v-model="overModel.grade" placeholder="请选择店铺等级">
                        <el-option label="A" :value="3"></el-option>
                        <el-option label="B" :value="2"></el-option>
                        <el-option label="C" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="复购天数：">
                    <el-input placeholder="多少天之后可以复购，0为永不复购" v-model="overModel.repurchase"></el-input>
                </el-form-item>
                <el-form-item label="好评间隔天数：">
                    <el-input placeholder="做单多少天之后催促刷手进行好评" v-model="overModel.praiseDay"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitOver">确 定</el-button>
            </div>
        </el-dialog>
                <el-image-viewer 
                v-show="showViewer" 
                :on-close="closeImg" 
                :url-list="[url]" />

        <el-dialog title="做单配置" :visible.sync="shopConfigFormVisible" width="400px">
            <el-form label-width="120px" :model="shopConfigModel"   ref="ruleForm" >
                <el-form-item label="店铺名称:">
                    <el-input placeholder="" v-model="shopConfigModel.Name"></el-input>
                </el-form-item>
                <el-form-item label="复购:">
                    <el-input placeholder="" v-model="shopConfigModel.Repurchase"></el-input>
                </el-form-item>
                <el-form-item label="关联复购：">
                    <el-input placeholder="" v-model="shopConfigModel.RelatedRepurchase"></el-input>
                </el-form-item>
                <el-form-item label="降权：">
                    <el-input placeholder="" v-model="shopConfigModel.ClaimJiangNum"></el-input>
                </el-form-item>
                <el-form-item label="周查询：">
                    <el-input placeholder="" v-model="shopConfigModel.ClaimWeekCount"></el-input>
                </el-form-item>
                <el-form-item label="周平均：">
                    <el-input placeholder="" v-model="shopConfigModel.ClaimWeekCreditAverage"></el-input>
                </el-form-item>
                <el-form-item label="信誉等级：">
                    <el-input placeholder="" v-model="shopConfigModel.ClaimBuyerGoodNum"></el-input>
                </el-form-item>
                <el-form-item label="淘龄：">
                    <el-input placeholder="" v-model="shopConfigModel.ClaimTaoAge"></el-input>
                </el-form-item>
                <el-form-item label="日订单：">
                    <el-input placeholder="" v-model="shopConfigModel.MaxOrderNum"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="shopConfigFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="setShopConfig">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { shopGet,shopPass,shopOver,commissionGetAll,shopClose,shopEnable,configGetCategory,SetShopConfig} from '@/request.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

export default {
    components: {
        ElImageViewer
    },
    data(){
        return {
            formId:0,
            url:"",
            showViewer:false,
            overScope:{},
            commissions:[],
            dialogFormVisible:false,
            shopConfigFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                queryTxt:"",
                pSize:20,
                pIndex:1,
                type:"",
                status:"",
                grade:"",
                categoryId:"",
                lastReleaseDay:"",
            },
            tableData:[],
            overModel:{
                id:0,
                remark:"",
                commissionId:"",
                categoryId:"",
                grade:"",
                repurchase:0,
                praiseDay:0,
                type:"",
                lastReleaseDay:"",
            },
            shopConfigModel:{
                Name:"",
                Repurchase:0,
                RelatedRepurchase:0,
                ClaimJiangNum:0,
                ClaimWeekCount:0,
                ClaimWeekCreditAverage:0,
                ClaimBuyerGoodNum:0,
                ClaimTaoAge:0,
                MaxOrderNum:0,
                Id:0
            },
            categorys:[],
        }
    },
    created(){
        commissionGetAll({},(res)=>{
            this.commissions=res.Result;
        });
        configGetCategory({},(res)=>{
            this.categorys=res.Result;
        })
        this.bodyHeight=document.documentElement.clientHeight-129;
        this.query();
    },
    mounted(){
       
    },
    methods: {
        setCommission(scope){
            console.log(scope);
        },
        showImg(url){
            this.url=url
            this.showViewer=true;
        },
        closeImg(){
            this.showViewer=false;
        },
        openShopConfig(info) {
this.shopConfigModel.Name = info.Name
            this.shopConfigModel.Repurchase = info.Repurchase
            this.shopConfigModel.RelatedRepurchase = info.RelatedRepurchase
            this.shopConfigModel.ClaimJiangNum = info.ClaimJiangNum
            this.shopConfigModel.ClaimWeekCount = info.ClaimWeekCount
            this.shopConfigModel.ClaimWeekCreditAverage = info.ClaimWeekCreditAverage
            this.shopConfigModel.ClaimBuyerGoodNum = info.ClaimBuyerGoodNum
            this.shopConfigModel.ClaimTaoAge = info.ClaimTaoAge
            this.shopConfigModel.MaxOrderNum = info.MaxOrderNum
            this.formTitle = '编辑'
            this.shopConfigFormVisible = true
            this.shopConfigModel.Id = info.Id
        },
        setShopConfig(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    SetShopConfig(this.shopConfigModel,()=>{
                this.$message({
                        message: "修改成功！",
                        type: 'success'
                    });
                    this.query()
                    this.shopConfigFormVisible = false
                    })
                    .catch(err => {
                        console.log(err)
                    })
                } else {
                    return false;
                }
            })
                    
            
        },
        submitOver() {
            if(this.overModel.type==""){
                this.$message({
                    message: '请选择店铺类型',
                    type: 'warning'
                });
                return
            }
            if(this.overModel.commissionId==""){
                this.$message({
                    message: '请选择一个佣金模板',
                    type: 'warning'
                });
                return
            }
            if(this.overModel.categoryId==""){
                this.$message({
                    message: '请选择一个店铺类目',
                    type: 'warning'
                });
                return
            }
            if(this.overModel.grade==""){
                this.$message({
                    message: '请选择一个等级',
                    type: 'warning'
                });
                return
            }
            shopPass({
                id:this.overModel.id,
                commissionTemplateId:this.overModel.commissionId,
                remark:this.overModel.remark,
                categoryId:this.overModel.categoryId,
                lastReleaseDay:this.overModel.lastReleaseDay,
                grade:parseInt(this.overModel.grade),
                repurchase:parseInt(this.overModel.repurchase),
                praiseDay:parseInt(this.overModel.praiseDay),
                type:parseInt(this.overModel.type)
            },(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    this.dialogFormVisible=false;
                    this.overScope.Status=2;
                    this.overScope.ReviewTime=res.Result.ReviewTime;
                    this.overScope.ReviewManagerName=res.Result.ReviewManagerName;
                    this.overScope.CommissionTemplateId=res.Result.CommissionTemplateId;
                    this.overScope.CommissionName=res.Result.CommissionName;
                    this.overScope.Repurchase=this.overModel.repurchase;
                    this.overScope.CategoryId=this.overModel.categoryId;
                    this.overScope.LastReleaseDay=this.overModel.lastReleaseDay;
                    this.overScope.Grade=this.overModel.grade;
                    this.overScope.type=this.overModel.type;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        pass(scope){
            this.overScope=scope;
            this.dialogFormVisible=true;
            this.overModel={
                id:scope.Id,
                remark:scope.ReviewRemark,
                commissionId:scope.CommissionTemplateId,
                grade:scope.Grade==0?"":scope.Grade,
                categoryId:scope.CategoryId==0?"":scope.CategoryId,
                lastReleaseDay:scope.LastReleaseDay,
                repurchase:scope.Repurchase,
                praiseDay:scope.PraiseDay,
                type:scope.Type==0?"":scope.Type,
            };
        },
        over(scope){
            this.$prompt('请填写不通过原因', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                }).then(({ value }) => {
                    shopOver({remark:value,id:scope.Id},(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            scope.Status=3;
                            scope.ReviewTime=res.Result.ReviewTime;
                            scope.ReviewRemark=value;
                            scope.ReviewManagerName=res.Result.ReviewManagerName;
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消操作'
                });       
            });

        },
        enable(scope){
            shopEnable({id:scope.Id},(res)=>{
                if(res.IsSuccess){
                    this.$message({
                        message: '启用成功',
                        type: 'success'
                    });
                    scope.Status=2;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        del(scope){
            this.$confirm('确认关闭该店铺吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(() => {
                shopClose({id:scope.Id},(res)=>{
                    if(res.IsSuccess){
                        this.$message({
                            message: '关闭成功',
                            type: 'success'
                        });
                        scope.Status=4;
                    }else{
                        this.$message.error(res.Message);
                    }
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消操作'
                });          
            });
        },
        query(){
            this.isLoading=true;
            shopGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                queryTxt:this.queryModel.queryTxt,
                type:this.queryModel.type==""?0:parseInt(this.queryModel.type),
                status:this.queryModel.status==""?0:parseInt(this.queryModel.status),
                grade:this.queryModel.grade==""?0:parseInt(this.queryModel.grade),
                categoryId:this.queryModel.categoryId==""?0:parseInt(this.queryModel.categoryId),
                lastReleaseDay:this.queryModel.lastReleaseDay==""?0:parseInt(this.queryModel.lastReleaseDay),

            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                pSize:this.queryModel.pSize,
                pIndex:this.queryModel.pIndex,
                type:"",
                status:"",
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>